import React from 'react';
import {
  SubmissionScoreEdit,
  ISubmission,
  ISubmissionScoreEditAssignment, ClassNames,
} from '@/components/shared/Grading/Navigation/SubmissionScoreEdit';
import useGradingStore from '../useGradingStore';

interface SubmissionScoreProps {
  classNames?: ClassNames;
  editable?: boolean;
  labelText?: string;
}

const SubmissionScore = ({ classNames = {}, editable = true, labelText }: SubmissionScoreProps) => {
  const assignment = useGradingStore(state => state.assignment);
  const submission = useGradingStore(state => state.submission);

  const submissionScoreAssignment = {
    ...assignment,
    maxScore: assignment.max_points.toString(),
  } as any as ISubmissionScoreEditAssignment;

  return (
    <SubmissionScoreEdit
      assignment={submissionScoreAssignment}
      classNames={{
        input: '[&>input]:tw-ml-0',
        label: 'tw-mb-2',
        root: 'tw-flex-col tw-items-start',
        saveStatus: 'tw-text-left tw-text-balance tw-whitespace-normal',
        ...classNames,
      }}
      editable={editable}
      labelText={labelText}
      submission={submission as any as ISubmission}
    />
  );
};

export default SubmissionScore;
